import moment from 'moment'

export default function (d1, d2) {
  const date1 = moment(d1)
  const date2 = moment(d2)
  return date1.valueOf() - date2.valueOf()
}
